export default "__VITE_ASSET__10b0cdfa__"